import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

const BOOKS: Record<string, { bucket: string; path: string; filename: string }> = {
  "yalnizlik-as": {
    bucket: "book-pdfs",
    path: "yalnizlik-as.pdf",
    filename: "Yalnizlik-AS-Arda-Oztaskin.pdf",
  },
};

export const getBookDownloadUrl = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((data: { slug: string }) => {
    if (!data || typeof data.slug !== "string" || !/^[a-z0-9-]{1,64}$/.test(data.slug)) {
      throw new Error("Geçersiz kitap.");
    }
    return data;
  })
  .handler(async ({ data, context }) => {
    const book = BOOKS[data.slug];
    if (!book) throw new Error("Kitap bulunamadı.");
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data: signed, error } = await supabaseAdmin.storage
      .from(book.bucket)
      .createSignedUrl(book.path, 60 * 5, { download: book.filename });
    if (error || !signed?.signedUrl) {
      throw new Error(error?.message ?? "İndirme bağlantısı oluşturulamadı.");
    }
    // Log the download. Must be awaited — unawaited promises are cancelled
    // when the Worker returns the response, so fire-and-forget loses inserts.
    // Wrapped in try/catch so a logging failure never blocks the download.
    try {
      const { error: logErr } = await supabaseAdmin
        .from("book_downloads")
        .insert({ book_slug: data.slug, user_id: context.userId });
      if (logErr) console.error("book_downloads insert failed", logErr);
    } catch (e) {
      console.error("book_downloads insert threw", e);
    }
    return { url: signed.signedUrl };

  });
